import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './funkprotokollierung.reducer';
import {FunkprotokollFallUi} from './funkprotokollierung.model.ui';
import {FunkprotokollEintrag, FunkprotokollFall, Meldeart} from '../../../clients/veranstaltungen';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';

export const getModuleState = createFeatureSelector<ModuleState>('FunkprotokollierungPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getAktuelleVeranstaltung = createSelector(getPageState, (state: PageState) => state.aktuelleVeranstaltung);

export const getListeProtokollAktiveFaelle = createSelector(getPageState, (state: PageState) => {
    const list = state.listeProtokollFaelle.filter(
        (x) => !x.ist_abgeschlossen
    ).map(
        x => {
            const letzterEintrag = x.eintraege.filter(
                (eintrag) => eintrag.eintrag_id === x.letzter_eintrag_id
            );
            return <FunkprotokollFallUi> Object.assign({}, x , {
                letzter_eintrag: (letzterEintrag.length === 1) ? letzterEintrag[0] : null
            });
        }
    );

    return list.map((item: FunkprotokollFall) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.fall_id,
        itemTitle: item.titel,
        item: item
    });
});

export const getListeProtokollAbgeschlosseneFaelle = createSelector(getPageState, (state: PageState) => {
    const list = state.listeProtokollFaelle.filter(
        (x) => x.ist_abgeschlossen
    ).map(
        x => {
            const letzterEintrag = x.eintraege.filter(
                (eintrag) => eintrag.eintrag_id === x.letzter_eintrag_id
            );
            return <FunkprotokollFallUi> Object.assign({}, x , {
                letzter_eintrag: (letzterEintrag.length === 1) ? letzterEintrag[0] : null
            });
        }
    );

    return list.map((item: FunkprotokollFallUi) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.fall_id,
        itemTitle: item.titel,
        item: item
    });
});

export const getAktuellerProtokollFall = createSelector(getPageState, (state: PageState) => state.aktuellerProtokollFall);

export const getIncident = createSelector(getPageState, (state: PageState) => state.incident);
export const getIncidentLaden = createSelector(getPageState, (state: PageState) => state.incidentLaden);
export const getIncidentFehler = createSelector(getPageState, (state: PageState) => state.incidentFehler);

export const getMeldearten = createSelector(getPageState, (state: PageState) => state.meldearten);
export const getMeldeartenLaden = createSelector(getPageState, (state: PageState) => state.meldeartenLaden);
export const getMeldeartenFehler = createSelector(getPageState, (state: PageState) => state.meldeartenFehler);

export const getAktuellerProtokollEintrag = createSelector(getPageState, (state: PageState) => {
    if (state.aktuellerProtokollEintrag === null) {
        return null;
    }

    let eintrag: FunkprotokollEintrag = Object.assign({}, state.aktuellerProtokollEintrag);

    const meldeartStandard = state.meldearten.find(x => x.ist_standard);

    if (eintrag.meldeart_id === null && meldeartStandard !== null && meldeartStandard !== undefined) {
        eintrag = Object.assign({}, state.aktuellerProtokollEintrag, {
            meldeart_text: meldeartStandard.text,
            meldeart_id: meldeartStandard.meldeart_id
        });
    }
    // console.log('Eintrag: ', eintrag);
    return eintrag;
});

export const getAktuellerProtokollFallMeldungen = createSelector(getAktuellerProtokollFall, getMeldearten, (aktuellerFall: FunkprotokollFall, meldearten: Array<Meldeart>) => {
    if (aktuellerFall === null) {
        return [];
    }

    const aktuelleMeldungen = aktuellerFall.eintraege.map((item: FunkprotokollEintrag) => {
        return <ListInputItem>{
            groupId: '',
            groupTitle: '',
            itemId: item.eintrag_id,
            itemTitle: item.text,
            item: item
        };
    });
    // console.log('Meldungen: ', aktuelleMeldungen);
    return aktuelleMeldungen;
});

/*
export const getVeranstaltungen = createSelector(getVeranstaltungenAktuell, getVeranstaltungenBeendet, (aktuell: Veranstaltung[], beendet: Veranstaltung[]) => {
    if (aktuell === null && beendet === null) {
        return [];
    }
    const aktuelleMap = aktuell.map((item: Veranstaltung) => <ListInputItem>{
        groupId: 'Aktuelle Veranstaltungen',
        groupTitle: 'Aktuelle Veranstaltungen',
        itemId: item.veranstaltung_id,
        itemTitle: item.titel,
        item: item
    });

    const beendeteMap = beendet.map((item: Veranstaltung) => <ListInputItem>{
        groupId: 'Beendete Veranstaltungen',
        groupTitle: 'Beendete Veranstaltungen',
        itemId: item.veranstaltung_id,
        itemTitle: item.titel,
        item: item
    });


    return aktuelleMap.concat(beendeteMap);
});
*/

export const getFunkVorlagenListe = createSelector(getPageState, (state: PageState) => state.funkVorlagenListe);
export const getFunkVorlagenListeLaden = createSelector(getPageState, (state: PageState) => state.funkVorlagenListeLaden);
export const getFunkVorlagenListeFehler = createSelector(getPageState, (state: PageState) => state.funkVorlagenListeFehler);
